import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SectionHero from '../../components/sections/SectionHero';
import SectionTrustBar from '../../components/sections/SectionTrustBar';
import SectionServices from '../../components/sections/SectionServices';
import SectionMidCTA from '../../components/sections/SectionMidCTA';
import SectionAIBlock from '../../components/sections/SectionAIBlock';
import SectionProcess from '../../components/sections/SectionProcess';
import SectionWhyUs from '../../components/sections/SectionWhyUs';
import SectionAreas from '../../components/sections/SectionAreas';
import SectionTestimonials from '../../components/sections/SectionTestimonials';
import SectionFAQ from '../../components/sections/SectionFAQ';
import SectionFinalCTA from '../../components/sections/SectionFinalCTA';

const services = [
  {
    icon: 'ri-seedling-line',
    title: 'Open Water Certification',
    description:
      'The world\'s most recognized scuba certification. Complete your eLearning, pool sessions, and 4 open water dives with our PADI/SSI instructors in Miami\'s warm coastal waters.',
    image:
      'https://public.readdy.ai/ai/img_res/09bf27f959273eb2c7d7ac67b72c8591.jpg',
  },
  {
    icon: 'ri-arrow-up-circle-line',
    title: 'Advanced Open Water',
    description:
      'Expand your skills with 5 adventure dives — deep diving, navigation, and specialty dives in Miami\'s diverse underwater environments.',
    image:
      'https://readdy.ai/api/search-image?query=advanced%20scuba%20diver%20deep%20underwater%20tropical%20ocean%20navigation%20dive%20computer%20professional%20equipment%20crystal%20clear%20water%20dramatic%20lighting%20adventure%20Miami%20reef&width=600&height=400&seq=svc-aow-v3&orientation=landscape',
  },
  {
    icon: 'ri-first-aid-kit-line',
    title: 'Rescue Diver Course',
    description:
      'Master the art of preventing and managing diving emergencies. Consistently rated the most rewarding course any diver can take.',
    image:
      'https://readdy.ai/api/search-image?query=rescue%20scuba%20diver%20training%20underwater%20emergency%20response%20professional%20diving%20certification%20two%20divers%20rescue%20skills%20practice%20clear%20ocean%20water%20professional%20training%20Miami&width=600&height=400&seq=svc-rescue-v3&orientation=landscape',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Divemaster Program',
    description:
      'Turn your passion into a profession. Complete Divemaster training under experienced professional supervision at our Miami waterfront facility.',
    image:
      'https://readdy.ai/api/search-image?query=divemaster%20professional%20scuba%20diving%20leading%20group%20divers%20underwater%20Miami%20tropical%20coral%20reef%20boat%20professional%20certification%20program%20guide%20instructor%20training&width=600&height=400&seq=svc-dm-v3&orientation=landscape',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Technical & TDI Programs',
    description:
      'Advanced trimix, decompression, and penetration diving for experienced divers seeking to push beyond recreational limits with TDI certification.',
    image:
      'https://readdy.ai/api/search-image?query=technical%20scuba%20diver%20deep%20water%20cave%20diving%20rebreather%20sidemount%20technical%20diving%20equipment%20wreck%20penetration%20advanced%20underwater%20dramatic%20dark%20professional&width=600&height=400&seq=svc-tech-v3&orientation=landscape',
  },
  {
    icon: 'ri-star-line',
    title: 'Specialty Certifications',
    description:
      'Wreck diving, night diving, underwater photography, enriched air nitrox, and 15+ more specialty programs to deepen your skills.',
    image:
      'https://readdy.ai/api/search-image?query=specialty%20scuba%20diving%20wreck%20diving%20night%20diving%20underwater%20photography%20coral%20reef%20colorful%20tropical%20marine%20life%20certification%20specialty%20course%20beautiful%20Florida%20Keys&width=600&height=400&seq=svc-spec-v3&orientation=landscape',
  },
];

const steps = [
  {
    number: '01',
    title: 'Choose Your Program',
    description: 'Select your certification level and complete online/eLearning theory at your own pace, anywhere.',
    icon: 'ri-file-list-3-line',
    detail: 'Flexible eLearning works on any device. Complete theory before you arrive.',
  },
  {
    number: '02',
    title: 'Pool Skills Training',
    description: 'Confined water sessions to master core skills in a controlled environment before the open ocean.',
    icon: 'ri-water-flash-line',
    detail: 'Every fundamental skill is practiced until it is confident and automatic.',
  },
  {
    number: '03',
    title: 'Open Water Certification Dives',
    description: 'Complete your certification dives in Miami\'s coastal waters from our Pier 5 dive boat.',
    icon: 'ri-ship-line',
    detail: 'Real ocean. Real conditions. Full professional supervision on every dive.',
  },
  {
    number: '04',
    title: 'Certified — Dive the World',
    description: 'Receive your internationally recognized certification card and dive anywhere in the world.',
    icon: 'ri-award-line',
    detail: 'PADI, SSI, and SDI cards accepted at every dive center globally.',
  },
];

const reasons = [
  {
    icon: 'ri-focus-3-line',
    title: 'No Shortcuts. No Rushing.',
    description: 'Every skill is properly taught and confirmed. We certify divers who are genuinely prepared for the ocean.',
  },
  {
    icon: 'ri-award-line',
    title: 'Five-Agency Accreditation',
    description: 'PADI, SSI, SDI, TDI, and ERDI certification. Your credential is recognized by every major diving organization worldwide.',
  },
  {
    icon: 'ri-anchor-line',
    title: 'Real Boat. Real Ocean. Real Training.',
    description: 'Certification dives happen from our Pier 5 dive boat on Biscayne Bay — not a quarry or a lake.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Instructors Who Actually Invest in You',
    description: 'Small class sizes and individual attention from instructors who are genuinely passionate about your development.',
  },
  {
    icon: 'ri-bar-chart-line',
    title: 'Clear Pathway to Divemaster and Beyond',
    description: 'A structured progression from Open Water through technical diving — as far as you want to go.',
  },
];

const areas = [
  'Miami', 'Miami Beach', 'South Beach', 'Brickell', 'Coconut Grove',
  'Coral Gables', 'Key Largo', 'Key West', 'Fort Lauderdale',
  'Biscayne Bay', 'Biscayne National Park',
];

const testimonials = [
  {
    name: 'Sofia M.',
    role: 'Open Water Certified — Miami Beach',
    rating: 5,
    quote:
      'I had serious anxiety about breathing underwater — Ace Diving\'s instructors were patient, thorough, and genuinely supportive every step of the way. I finished my certification in 4 days feeling completely capable and confident. The boat dives on Biscayne Bay were absolutely incredible.',
    avatar:
      'https://readdy.ai/api/search-image?query=smiling%20confident%20woman%20headshot%20portrait%20natural%20outdoor%20light%20professional%20casual%20friendly%20warm%20expression&width=100&height=100&seq=avatar-svc-1-v3&orientation=squarish',
  },
  {
    name: 'Anthony B.',
    role: 'Divemaster — Biscayne Bay',
    rating: 5,
    quote:
      'Did my entire journey from Open Water to Divemaster with Ace Diving. The instruction quality at every level was exceptional — structured, demanding in the right ways, and led by instructors who genuinely care about your growth as a diver.',
    avatar:
      'https://readdy.ai/api/search-image?query=confident%20professional%20man%20portrait%20headshot%20casual%20outdoor%20background%20friendly%20natural%20warm%20light&width=100&height=100&seq=avatar-svc-2-v3&orientation=squarish',
  },
  {
    name: 'Rachel K.',
    role: 'Rescue Diver — Coral Gables',
    rating: 5,
    quote:
      'The rescue course completely changed how I think about diving and my responsibilities underwater. Challenging, comprehensive, and run by instructors who hold you to a real professional standard. Best course I\'ve ever taken.',
    avatar:
      'https://readdy.ai/api/search-image?query=professional%20confident%20woman%20casual%20portrait%20smiling%20outdoor%20natural%20light%20headshot%20warm%20background&width=100&height=100&seq=avatar-svc-3-v3&orientation=squarish',
  },
];

const faqs = [
  {
    question: 'What scuba certifications does Ace Diving Miami offer?',
    answer:
      'Ace Diving Miami offers PADI, SSI, SDI, TDI, and ERDI certifications — from Open Water and Advanced Open Water through Rescue Diver, Divemaster, and full technical diving programs. They also offer 15+ specialty certifications including wreck, night diving, nitrox, and underwater photography.',
  },
  {
    question: 'How long does Open Water scuba certification take in Miami?',
    answer:
      'Most Open Water certification programs can be completed in 3–5 days. This includes online eLearning theory at your own pace, confined water pool sessions, and 4 open water certification dives in Miami\'s warm, clear coastal waters from Pier 5, Biscayne Bay.',
  },
  {
    question: 'Can I start scuba training with zero experience?',
    answer:
      'Absolutely. No prior diving experience is required for Open Water certification. You need basic swimming ability and comfort in the water. Ace Diving\'s instructors guide you through every step — from your very first breath underwater to your certification dives in the Atlantic.',
  },
  {
    question: 'What is the difference between PADI and SDI certification?',
    answer:
      'Both PADI and SDI are globally recognized scuba certifications accepted worldwide. PADI is the world\'s largest training organization. SDI is popular for its flexible eLearning approach and direct pathway to technical diving through TDI. Ace Diving is accredited by both — your instructor will recommend the best fit.',
  },
  {
    question: 'Does Ace Diving offer private or accelerated scuba courses in Miami?',
    answer:
      'Yes. Private and semi-private certification courses are available for faster completion and highly personalized instruction. Ace Diving also offers weekend and evening schedules. Contact the team at +1 786-241-3194 to discuss the format that fits your timeline.',
  },
];

export default function Services() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <SectionHero
          eyebrow="Scuba Certification Programs · Miami, FL"
          headline={
            <>
              The Certification<br />
              Programs That<br />
              <span className="text-[#00B4D8]">Actually Prepare You.</span>
            </>
          }
          subheadline="From your first breath underwater to divemaster and technical diving — structured, safety-first certification programs led by multi-agency certified instructors in Miami."
          cta1={{ text: 'Enroll in a Program', href: '#contact' }}
          cta2={{ text: 'Speak With a Specialist', href: 'tel:+17862413194' }}
          stats={[
            { value: 'PADI', label: 'SSI · SDI · TDI · ERDI' },
            { value: '6+', label: 'Cert Levels' },
            { value: '15+', label: 'Specialty Programs' },
            { value: '100%', label: 'Safety Record' },
          ]}
          backgroundImage="https://readdy.ai/api/search-image?query=professional%20scuba%20diver%20underwater%20certification%20training%20clear%20water%20miami%20ocean%20instructor%20student%20professional%20equipment%20dramatic%20sunlight%20rays%20marine%20life%20wide%20angle%20beautiful&width=1920&height=1080&seq=hero-svc-v3&orientation=landscape"
          backgroundAlt="Scuba certification training Miami — Ace Diving"
        />
        <SectionTrustBar />
        <SectionServices
          eyebrow="Certification Programs"
          headline="Scuba Certifications for Every Level — Beginner to Technical"
          services={services}
          ctaText="Enroll in a Program"
        />
        <SectionMidCTA
          headline="Not Sure Which Program Is Right for You?"
          subheadline="Our dive specialists will match you with the perfect certification level based on your goals, experience, and schedule."
          cta1={{ text: 'Get a Recommendation', href: '#contact' }}
          cta2={{ text: '+1 786-241-3194', href: 'tel:+17862413194' }}
        />
        <SectionAIBlock
          eyebrow="About Our Programs"
          headline="What Do Ace Diving's Certification Programs Include?"
          lead="Ace Diving Miami provides a complete progression pathway — from entry-level Open Water certification through Rescue Diver, Divemaster, and full technical diving programs — all certified by PADI, SSI, SDI, TDI, and ERDI."
          paragraphs={[
            'Each program includes structured theory, confined water skills practice, and real open water dives from their Pier 5 dive boat on Biscayne Bay. Small class sizes ensure every student receives individual attention from instructors who prioritize genuine competence over speed.',
            'Programs can be completed on flexible schedules including weekends, evenings, and accelerated formats — making professional scuba certification accessible regardless of your lifestyle.',
          ]}
          tags={[
            'Open Water',
            'Advanced Open Water',
            'Rescue Diver',
            'Divemaster',
            'Technical Diving',
            'Nitrox',
            'Wreck Diving',
            'Night Diving',
          ]}
        />
        <SectionProcess
          eyebrow="How Certification Works"
          headline="From Enrollment to Certified Diver — A Clear, Structured Path"
          steps={steps}
          ctaText="Enroll Today"
        />
        <SectionWhyUs
          eyebrow="Why Train With Ace Diving"
          headline="Why Miami Divers Choose Ace Diving for Certification"
          reasons={reasons}
          image="https://readdy.ai/api/search-image?query=scuba%20instructor%20professional%20teaching%20underwater%20student%20open%20water%20certification%20training%20Miami%20ocean%20boat%20dive%20professional%20equipment%20instructor%20student%20portrait%20cinematic&width=700&height=900&seq=why-svc-v3&orientation=portrait"
          imageAlt="Ace Diving certification instructor Miami"
          ctaText="Enroll in a Program"
          badge1={{ label: 'PADI / SSI / SDI / TDI / ERDI', sublabel: 'All Major Agencies' }}
          badge2={{ value: '6+', label: 'Cert Levels' }}
        />
        <SectionAreas
          eyebrow="Training Locations"
          headline="Scuba Certification Training in Miami & South Florida"
          description="All certification programs are conducted from Ace Diving's waterfront facility at Pier 5 on Biscayne Blvd. Open water certification dives take place in Miami's beautiful warm coastal waters — some of the best diving environments in the United States."
          areas={areas}
          ctaText="Check Program Availability"
        />
        <SectionTestimonials
          eyebrow="Student Experiences"
          headline="What Students Say About Their Ace Diving Certification"
          testimonials={testimonials}
          ctaText="Enroll in a Program"
        />
        <SectionFAQ
          eyebrow="Program Questions"
          headline="Common Questions About Scuba Certification in Miami"
          faqs={faqs}
        />
        <SectionFinalCTA
          eyebrow="Enroll Today"
          headline="Ready to Become a Certified Scuba Diver in Miami?"
          subheadline="Fill out the form and our team will match you with the right certification program, schedule, and pricing — no commitment required."
          ctaText="Enroll in a Program"
        />
      </main>
      <Footer />
    </div>
  );
}
